// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Paginator_pagination__NU1g_","active":"Paginator_active__3yKRk"};